import * as React from 'react';
import { style } from 'typestyle';

import { HelpService } from '~commonInfra/services/HelpService';
import { getAppStore } from '~src/app/AppStore';
import { ExplorerEmptyStateProps } from '~src/app/spaces/Components/ExplorerEmpyState';
import { ConnectedExplorer } from '~src/app/spaces/Explorer/ConnectedExplorer';
import { ConnectedQueryParamUpdateProvider } from '~src/app/spaces/RouterHelpers/QueryParamUpdateProvider';
import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

import { CreateConnectedApplicationAction, newConnectedApplicationButton } from './AddConnectedApplicationButton';

export const DescriptionSectionName = 'connectedApplicationsDescription';

const cssPrefix = 'ConnectedApplications';
const tableStyle = cssClass(cssPrefix, 'space-subplace-area', {
  flex: 1,
  position: 'relative',
  minHeight: 250,
});

function tableSection(props: ConnectedApplicationSettingSubspaceProps) {
  return <div className={tableStyle}>
    <ConnectedQueryParamUpdateProvider
      shouldUpdateFilters={true}
      shouldUpdateContentTypes={false}
      shouldUpdateBreadcrumbs={false}
      shouldUpdateSort={true}
      routeLocationSearch={props.search}
      routeLocationPath={props.pathname}>
      <ConnectedExplorer
        supportedDisplayModes={['list']}
        emptyStateProps={emptyStateProps()}
        toolbarProps={{
          supportFilterPanel: true,
          toolbarVisibility: 'enabled',
          hideSelection: false,
          toolbarContentSpecificControls: {
            beginning: newConnectedApplicationButton()
          }
        }}
      />
    </ConnectedQueryParamUpdateProvider>
  </div>;
}

const settingsSectionListFullWidthStyle = style({
  marginLeft: 15,
  marginRight: 15,
  paddingBottom: 20
});

const settingsFormStyle = style({
  flex: 1,
  display: 'flex',
  paddingTop: 30,
  overflow: 'auto',
  flexDirection: 'column',
});

export interface ConnectedApplicationSettingSubspaceProps {
  search: string;
  pathname: string;
}

// Note it's called ConnectedApplication... not because it's "Connected" like the Connected
// Explorer is, but because the item type is "Connected Application"
export function ConnectedApplicationSettingSubspace(props: ConnectedApplicationSettingSubspaceProps) {
  return <>
    <div className={settingsFormStyle}>
      <div className={settingsSectionListFullWidthStyle}>
        <div className="tb-settings-group-name" data-tb-test-id={DescriptionSectionName + '-header'}>
          {Messages.connectedApplications()}
        </div>
        <div className="tb-indent" data-tb-test-id={DescriptionSectionName + '-body'}>
          {Messages.connectedApplicationsDescription()}
          <a href={HelpService.getServerHelpUrlByCategory('connected-apps')}>{Messages.learnMore()}</a>
        </div>
      </div>
      {tableSection(props)}
    </div>
  </>;
}

function emptyStateProps(): ExplorerEmptyStateProps {
  const reduxAction = CreateConnectedApplicationAction.createReduxAction();
  const handleClick = () => getAppStore().dispatch(reduxAction);

  return {
    dataTestId: 'action-create-new-connected-application',
    primaryMessage: Messages.connectedApplicationsEmptyMessage(),
    actionButtonMessage: Messages.connectedApplicationNewConnectedApplicationButton(),
    onActionButton: handleClick
  };
}
